// extracted by mini-css-extract-plugin
export default {"nonEditable":"caseTypeSelector_nonEditable__gfTyo","wrapper":"caseTypeSelector_wrapper__65xkc"};